import { mdiCircle } from '@mdi/js'
import Icon from '@mdi/react'
import { I18nContext } from 'contexts/I18n/I18nProvider'
import { getOffsetInMS } from 'core/utils/date-utils'
import { useContext } from 'react'
import { iconSize } from '../../constants'
import { formatDate, getCASLicenseServerStatusColor, getClientDataBrokerCheckColor, getDate, getDeviceAuthenticationTokenStatusColor, getVIPConnectivityCheckStatusColor } from '../../utils'

type StatusSectionProps = {
  STBMD: string
  VIPConnectivityCheck: number
  lastTechnicalDataEvent: string
  clientDataBrokerCheck: number
  authenticationTokenDate: string
  dvsd: string
  offset: number
}

export default function StatusSection({ VIPConnectivityCheck, STBMD, clientDataBrokerCheck, lastTechnicalDataEvent, authenticationTokenDate, dvsd, offset }: StatusSectionProps) {
  const t = useContext(I18nContext)
  const currentTime = Date.now()

  return (
    <div className="section">
      <h3 className="section-title">{t('device_checks.labels_status')}</h3>
      <div className="columns">
        <div className="column is-6">{t('device_checks.labels_vip_connectivity_check')}:</div>
        <div className="column is-6">
          <div className="status-column">
            <Icon path={mdiCircle} size={iconSize} color={getVIPConnectivityCheckStatusColor(VIPConnectivityCheck, STBMD, currentTime + getOffsetInMS(offset))} />
            <span>{getDate(VIPConnectivityCheck, t)}</span>
          </div>
        </div>
      </div>
      <div className="divider" />
      <div className="columns">
        <div className="column is-6">{t('device_checks.labels_client_data_broker_check')}:</div>
        <div className="column is-6">
          <div className="status-column">
            <Icon path={mdiCircle} size={iconSize} color={getClientDataBrokerCheckColor(clientDataBrokerCheck, currentTime + getOffsetInMS(offset))} />
            <span>{getDate(clientDataBrokerCheck, t)}</span>
          </div>
        </div>
      </div>
      <div className="divider" />
      <div className="columns">
        <div className="column is-6">{t('device_checks.labels_device_authentication_token')}:</div>
        <div className="column is-6">
          <div className="status-column">
            <Icon path={mdiCircle} size={iconSize} color={getDeviceAuthenticationTokenStatusColor(authenticationTokenDate, currentTime)} />
            <span>{getDate(new Date(authenticationTokenDate).getTime(), t)}</span>
          </div>
        </div>
      </div>
      <div className="divider" />
      <div className="columns">
        <div className="column is-6">{t('device_checks.labels_last_technical_data_event')}:</div>
        <div className="column is-6">{formatDate(lastTechnicalDataEvent, t)}</div>
      </div>
      <div className="divider" />
      <div className="columns">
        <div className="column is-6">{t('device_checks.labels_cas_license_server')}:</div>
        <div className="column is-6">
          <div className="status-column">
            <Icon path={mdiCircle} size={iconSize} color={getCASLicenseServerStatusColor(dvsd, currentTime)} />
            <span>{formatDate(dvsd, t)}</span>
          </div>
        </div>
      </div>
      <div className="divider" />
    </div>
  )
}
